function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.5023 136.02C273.26 65.71 639.867 -50.1405 777.559 23.7287C915.25 97.5978 634.559 91.2486 806.918 303.954C979.278 516.659 861.107 517 769.865 517C678.623 517 346.861 384.068 209.705 462.433C72.5486 540.798 -93.1131 188.516 63.5023 136.02Z",
  fill: "#00ADB5",
  fillOpacity: 0.08
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 620,
  y: 310,
  width: 37,
  height: 92,
  transform: "rotate(-90 620 310)",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 833.5,
  cy: 190.5,
  r: 37.5,
  fill: "#00ADB5",
  fillOpacity: 0.08
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M117.773 301.045H216.364V344H240.5V301.045H269.136V278.545H240.5V134.545H209.818L117.773 280.182V301.045ZM216.364 278.545H145.182V276.909L214.727 166.864H216.364V278.545Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M538.773 301.045H637.364V344H661.5V301.045H690.136V278.545H661.5V134.545H630.818L538.773 280.182V301.045ZM637.364 278.545H566.182V276.909L635.727 166.864H637.364V278.545Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M482.5 242.707C482.5 278.59 472.987 300.807 459.429 314.12C445.824 327.48 426.49 333.5 403.5 333.5C380.51 333.5 361.176 327.48 347.571 314.12C334.013 300.807 324.5 278.59 324.5 242.707C324.5 206.829 334.03 180.76 348.25 163.853C362.361 147.075 381.742 138.5 403.5 138.5C425.258 138.5 444.639 147.075 458.75 163.853C472.97 180.76 482.5 206.829 482.5 242.707Z",
  stroke: "black",
  strokeWidth: 21
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 634,
  y: 254,
  width: 37,
  height: 95,
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M786.583 377.333H775.392L771.425 373.508C785.308 357.358 793.667 336.392 793.667 313.583C793.667 262.725 752.442 221.5 701.583 221.5C650.725 221.5 609.5 262.725 609.5 313.583C609.5 364.442 650.725 405.667 701.583 405.667C724.392 405.667 745.358 397.308 761.508 383.425L765.333 387.392V398.583L836.167 469.275L857.275 448.167L786.583 377.333ZM701.583 377.333C666.308 377.333 637.833 348.858 637.833 313.583C637.833 278.308 666.308 249.833 701.583 249.833C736.858 249.833 765.333 278.308 765.333 313.583C765.333 348.858 736.858 377.333 701.583 377.333Z",
  fill: "#00ADB5"
});

var Svg404 = function Svg404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 907 519",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/404.9bfe954f.svg";
export { ForwardRef as ReactComponent };